import { observable } from 'mobx';
import useMount from '@src/utils/hooks/use-mount';
import { getOmniData, strategy } from '@src/services/omni-api';
import createHtmlLink from '@src/utils/create-html-link';
import buildRouteUrl, { isAbsoluteUrl } from '@src/utils/build-route-url';

const styles = require('./index.less');

class StrategyStore {
  @observable isActive = false;
  @observable config = {};
  @observable strategyImgs = [];

  @observable currentTab = '';
  // @observable tabs = [{ id: 1, name: '最新' }, { id: 2, name: '新手' }, { id: 3, name: '门派' }, { id: 4, name: '玩法' }, { id: 5, name: '进阶' }];
  @observable tabs = strategy;
  @observable allData = {};
  @observable news = [];

  changeTab = currentTab => {
    if (this.currentTab === currentTab) {
      return;
    }
    this.currentTab = currentTab;
    this.setCurrentList();
  };

  getData = async () => {
    const dataSources = Object.keys(this.tabs).map(tab => {
      return {
        dataSourceId: tab || '',
        page: 1,
        perPage: 10
      };
    });
    dataSources.push({
      dataSourceId: 'ds_cat_77036ec5' || '',
      page: 1,
      perPage: 10
    });
    // 设置默认选中项
    this.currentTab = Object.keys(this.tabs)[0];
    // 获取列表数据
    const res = await getOmniData('channel_cat_881beee2', dataSources);
    // console.log('攻略数据', res);
    this.allData = res || {};
    this.setCurrentList();

    // 设置置顶banner数据
    const strategyImgs = this.allData['ds_cat_77036ec5']?.result?.items || [];
    this.strategyImgs = strategyImgs.map(item => ({
      ...item,
      name: item.title,
      img: item.top_banner_img?.[0]?.url || ''
    }));
  };

  setCurrentList = () => {
    this.news = this.allData[this.currentTab]?.result?.items || [];
  };

  gotoDetail = item => {
    if (!item) {
      return;
    }
    const jumpLink = typeof item.jump_link === 'string' ? item.jump_link.trim() : '';
    if (jumpLink === 'stay') {
      return;
    }
    let url = '';
    if (isAbsoluteUrl(jumpLink)) {
      // 置顶Banner 等条目由 CMS 直接配置完整链接(已带正确的 contentId/categoryId), 直接使用
      url = jumpLink;
    } else if (jumpLink === 'link') {
      url = item.art_link?.url;
    } else {
      // hash 路由: 参数必须拼在 #/strategy-detail 之后, 否则前端路由取不到
      url = buildRouteUrl('/strategy-detail', {
        contentId: item.contentId,
        categoryId: this.currentTab,
        page: 1
      });
    }
    if (!url) {
      return;
    }
    const link = createHtmlLink(url);
    link.target = '_blank';
    link.click();
  };

  gotoList = categoryId => {
    const url = buildRouteUrl('/strategy-list', { categoryId });
    const link = createHtmlLink(url);
    link.target = '_blank';
    link.click();
  };

  constructor({ ...rest } = {}) {
    Object.assign(this, rest);
  }

  use() {
    useMount(() => {
      this.getData();
    });
  }
}
export default StrategyStore;
